module.exports = __webpack_public_path__ + "img/video-img.1dd8d895.png";